import {
    FORMAT_SD_CARD_OPEN_MODAL,
    FORMAT_SD_CARD_CLOSE_MODAL,
    FORMAT_SD_CARD_REQUEST,
    FORMAT_SD_CARD_RESULT,
} from 'Redux/actionTypes';

export const formatSDCardOpenModal = () => ({
    type: FORMAT_SD_CARD_OPEN_MODAL
})

export const formatSDCardCloseModal = () => ({
    type: FORMAT_SD_CARD_CLOSE_MODAL
})

export const formatSDCardRequest = (data) => ({
    type: FORMAT_SD_CARD_REQUEST,
    payload: data
})

export const formatSDCardResult = (result) => ({
    type: FORMAT_SD_CARD_RESULT,
    payload: result
})